import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { Sector } from "../../../../domain/sector/sector"
import { SectorUiService } from '../../services/sector-ui.service';
import { IconComponent } from '../../../../shared/components/ui/icon/icon.component';
import { SectorState, SectorStateReason } from 'libs/domain/sector/enum-sectors';
import { BadgeComponent } from '../../../../shared/components/ui/badge/badge.component';
import { CommonModule } from '@angular/common';
import { SectorStateReasonBadge } from "../sector-state-reason-badge/sector-state-reason-badge";


@Component({
  selector: 'lib-sector-detail-card',
  imports: [IconComponent, BadgeComponent, CommonModule, SectorStateReasonBadge],
  templateUrl: './sector-detail-card.html',
})
export class SectorDetailCardComponent {
  sectorUiService = inject(SectorUiService)
  router = inject(Router);

  SectorState = SectorState;
  SectorStateReason = SectorStateReason;

  sector = input.required<Sector>();

  iconStateName = computed(() => {
    return this.sectorUiService.getSectorIconStateName(this.sector().state, this.sector().mode);
  });

  sectorStateString = computed(() => {
    return this.sectorUiService.getSectorStateString(this.sector().state);
  });

  sectorModeString = computed(() => {
    return this.sectorUiService.getSectorModeString(this.sector().mode);
  });

  schedulingPersonIcon = computed(() => {
    return this.sectorUiService.getSectorUserIconName(this.sector().schedulingPersonType);
  });
}
